var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"max-width":"400","content":_vm.getConditionsLabel(),"disabled":_vm.conditions.length === 0 || _vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }